import type { Step } from "react-joyride";

export const formAnalysisTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າວິເຄາະຟອມ! ທ່ານຈະໄດ້ເບິ່ງສະຖິຕິ, ຜະແນການ, ແລະຂໍ້ມູນການວິເຄາະກ່ຽວກັບຟອມ. ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີໃຊ້ງານຫນ້ານີ້ໃນບົດສອນສັ້ນໆນີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="analysis-header"]',
    content: "ນີ້ແມ່ນສ່ວນຫົວຂໍ້ຂອງຫນ້າວິເຄາະ. ທ່ານສາມາດເບິ່ງຊື່ຟອມ, ສະຖານະ, ແລະປຸ່ມການກະທຳ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="analysis-stats"]',
    content:
      "ນີ້ແມ່ນພາກສະຖິຕິຫຼັກ. ທ່ານສາມາດເບິ່ງຈຳນວນການສົ່ງ, ຜູ້ໃຊ້ທີ່ໃຊ້ງານ, ແລະເວລາສຳເລັດສະເລ່ຍ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="analysis-trends"]',
    content:
      "ນີ້ແມ່ນພາກຜະແນການການສົ່ງ. ທ່ານສາມາດເບິ່ງຜະແນການການສົ່ງຟອມໃນໄລຍະເວລາຕ່າງໆ. ທ່ານສາມາດເລືອກໄລຍະເວລາເພື່ອເບິ່ງຜະແນການທີ່ແຕກຕ່າງກັນ.",
    placement: "top",
  },
  {
    target: '[data-tourid="analysis-resources"]',
    content:
      "ນີ້ແມ່ນພາກແຫຼ່ງຂໍ້ມູນ. ທ່ານສາມາດເບິ່ງແລະຈັດການແຫຼ່ງຂໍ້ມູນທີ່ກ່ຽວຂ້ອງກັບຟອມເຊັ່ນ ແບບຟອມ, ຄູ່ມື, ແລະເອກະສານອື່ນໆ.",
    placement: "top",
  },
];
